module.exports = __webpack_public_path__ + "img/hp-h2.5a355b1c.svg";